export default "__VITE_ASSET__B2LT7kBo__"